var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccess)?_c('div',[_c('PageHeader',{attrs:{"title":"Gestion équipe CM","description":"Gestion des community managers","button":{
      icon: 'fas fa-plus-circle',
      text: 'Ajouter un community manager',
      action: _vm.openCreateModal
    }}}),_c('PageContent',[_c('MVPTable',{attrs:{"grid-data":_vm.communityManagers,"options":_vm.gridOptions,"statusBarType":"displayed"},on:{"gridReady":_vm.onGridReady,"rowDoubleClicked":_vm.openEditModal}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }